import SearchSvg from '../svg/search.svg';
import { IconProps } from '../IconProps';
import { BaseIcon } from './BaseIcon';
import React from 'react';

export const SearchIcon = (props: IconProps) => <BaseIcon src={SearchSvg} {...props} />;
SearchIcon.defaultProps = {
    alt: 'refer to self',
    width: '41px',
    height: '36px',
};
